import { toast } from "react-toastify";
import { fetchEditOperatorSuccess, fetchEditOperatorFailure } from "./reducer";
import { setEditSuccessMessage } from "../../toastMessage/action";
import { OPERATOR_CREATE_AND_EDIT_API } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { documentUpdateFile } from "../../customer/documentupdatefile/thunk";
import { documentUpdateJson, uploadDocApiCall } from "../../../Components/OperatorManagement/Constant/OperatorListingJson";
import { useState } from "react";
import { fetchOperatorbyId } from "../GetOperatorbyID/thunk";
import { buildConfigurationPayload, createConfigArray } from "../../../Components/OperatorManagement/Constant/ConfigFunction";
import { updateConfigOperator } from "../UpdateConfiguration/thunk";
import { createConfigOperator } from "../ConfigurationCreateOperator/thunk";

// function excludeUnchangedConfigs(newConfigs, existingConfigs) {

//     return newConfigs.filter((newConfig) => {
//         const existingConfig = existingConfigs?.configurations?.find(
//             (config) => config?.name === newConfig?.name
//         );
//         if (!existingConfig) {
//             return true; 
//         }
//         if (newConfig?.value?.length !== existingConfig?.value?.length) {
//             return true;
//         }
//         return !newConfig?.value?.every((newValueItem, index) => {
//             const existingValueItem = existingConfig?.value[index];
//             return (
//                 newValueItem?.key === existingValueItem?.key &&
//                 newValueItem?.value?.join() === existingValueItem?.value?.join()
//             );
//         });
//     });
// }

function excludeUnchangedConfigs(newConfigs, existingConfigs) {
    const result = {};

    const existingMap = existingConfigs?.configurations || {};

    for (const [configName, newConfig] of Object.entries(newConfigs || {})) {

        const existingConfig = existingMap[configName];

        // If config doesn't exist before → it's new
        if (!existingConfig) {
            result[configName] = newConfig;
            continue;
        }

        const newValues = newConfig?.value || {};
        const oldValues = existingConfig?.value || {};

        const newKeys = Object.keys(newValues);
        const oldKeys = Object.keys(oldValues);

        // If number of keys differ → changed
        if (newKeys.length !== oldKeys.length) {
            result[configName] = newConfig;
            continue;
        }

        let changed = false;

        for (const key of newKeys) {

            if (!oldValues.hasOwnProperty(key)) {
                changed = true;
                break;
            }

            const newVal = newValues[key]?.value;
            const oldVal = oldValues[key]?.value;

            if (Array.isArray(newVal) || Array.isArray(oldVal)) {

                const arr1 = Array.isArray(newVal) ? newVal : [newVal];
                const arr2 = Array.isArray(oldVal) ? oldVal : [oldVal];

                if (arr1.length !== arr2.length || arr1.join() !== arr2.join()) {
                    changed = true;
                    break;
                }

            } else if (newVal !== oldVal) {
                changed = true;
                break;
            }
        }

        if (changed) {
            result[configName] = newConfig;
        }
    }

    return result;
}

export const editOperator = (jsonObj, operatorId, setLoading, navigate, profile, update, setUpdate, fileSelected, logoFile, editData, setFileSelected, setEditData, finalValues, configData, defaultConfigurations) => async (dispatch) => {
    setLoading(true)
    const initialValues = {};
    const operatorOptions = [];
    const OperatorStatusOptions = [];
    const roleName = localStorage.getItem('roleName')
    await determineBaseUrlAndPerformApiCall(`${OPERATOR_CREATE_AND_EDIT_API}/${operatorId}`, 'PATCH', jsonObj).then((response) => {
        // if (response.error) {
        //     dispatch(fetchEditOperatorFailure(response.error.message))
        //     setLoading(false)
        //     toast.error(`${response.error.message}`)
        // }
        if (response.error) {
            if (configData?.error)
                configData = []
            setLoading(false)
            dispatch(fetchEditOperatorSuccess(response))
            const tasks = [];
            let jsonObj
            if (finalValues) {
                // const configArray = createConfigArray(finalValues, response);
                const configArray = buildConfigurationPayload(finalValues, defaultConfigurations, response);
                const filteredConfigs = Object.fromEntries(
                    Object.entries(excludeUnchangedConfigs(configArray, configData) || {}).filter(
                        ([configName]) => {
                            const matchingDefaultConfig = defaultConfigurations?.find(
                                d => d?.name?.toLowerCase() === configName.toLowerCase()
                            );
                            return matchingDefaultConfig?.scope?.includes(roleName);
                        }
                    )
                );
                jsonObj = {
                    "configurations": filteredConfigs,
                    "operatorId": response?.data?.adminDetails?.operatorId
                }
            }

            // function deepEqualConfig(config, json) {
            //     return config?.configurations?.every(configItem => {
            //         const matchFound = json.configurations.some(jsonItem => {
            //             if (configItem.name !== jsonItem.name) {
            //                 return false;
            //             }

            //             if (configItem.value.length !== jsonItem.value.length) return false;

            //             return configItem.value.every((configValueItem, valueIndex) => {
            //                 const jsonValueItem = jsonItem.value[valueIndex];
            //                 return configValueItem.key === jsonValueItem.key &&
            //                     configValueItem.value.join() === jsonValueItem.value.join();
            //             });
            //         });
            //         return matchFound;
            //     });
            // }
            function deepEqualConfig(configA, configB) {

                const mapA = configA?.configurations || {};
                const mapB = configB?.configurations || {};

                const keysA = Object.keys(mapA);
                const keysB = Object.keys(mapB);

                if (keysA.length !== keysB.length) return false;

                for (const configName of keysA) {

                    const cfgA = mapA[configName];
                    const cfgB = mapB[configName];

                    if (!cfgB) return false;

                    const valuesA = cfgA?.value || {};
                    const valuesB = cfgB?.value || {};

                    const valKeysA = Object.keys(valuesA);
                    const valKeysB = Object.keys(valuesB);

                    if (valKeysA.length !== valKeysB.length) return false;

                    for (const key of valKeysA) {

                        const valA = valuesA[key]?.value;
                        const valB = valuesB[key]?.value;

                        if (Array.isArray(valA) || Array.isArray(valB)) {

                            const arrA = Array.isArray(valA) ? valA : [valA];
                            const arrB = Array.isArray(valB) ? valB : [valB];

                            if (arrA.length !== arrB.length || arrA.join() !== arrB.join()) {
                                return false;
                            }

                        } else if (valA !== valB) {
                            return false;
                        }
                    }
                }

                return true;
            }

            if (configData?.length === 0) {
                tasks.push(dispatch(createConfigOperator(jsonObj, setLoading, navigate, false)));
            }
            if (!deepEqualConfig(configData, jsonObj)) {
                tasks.push(dispatch(updateConfigOperator(jsonObj, setLoading, navigate, false)))
            }
            if (logoFile) {
                if (profile && update) {
                    setUpdate(false)
                }
                if (fileSelected && logoFile !== null) {
                    if (profile && update) {
                        const jsonObj = documentUpdateJson(logoFile, operatorId, editData)
                        let partnerOrCustomer = "Operator";
                        tasks.push(dispatch(documentUpdateFile(setLoading, jsonObj, operatorId, editData?.tradingName, partnerOrCustomer, setUpdate, setFileSelected, navigate)))
                    }
                    else {
                        tasks.push(uploadDocApiCall(logoFile, operatorId, editData, setLoading, setFileSelected, dispatch, navigate))
                    }
                }
                else {
                    navigate('/operator-listing');
                    dispatch(setEditSuccessMessage(true))
                }
            }
            if (tasks.length > 0) {
                Promise.all(tasks).then(() => {
                    dispatch(setEditSuccessMessage(true));
                });
            } else {
                navigate('/operator-listing');
                dispatch(setEditSuccessMessage(true));
            }

            if (roleName === "systemUser") {
                // navigate('/operator-listing');
                dispatch(setEditSuccessMessage(true))
            }
            else if (roleName !== "systemUser") {
                dispatch(fetchOperatorbyId(setLoading, operatorId, initialValues, operatorOptions, OperatorStatusOptions, setEditData));
                navigate('/dashboard');
                dispatch(setEditSuccessMessage(true))
            }
        }
    }).catch((errorResp) => { console.error("[Error in the EditOperator method", errorResp) })
};